export default __webpack_public_path__ + "static/media/manage-hashtag.f2ac7d38.svg";